export default function X({ className }: SvgProps) {
  return (
    <svg
      className={className}
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.7319 16.9487L0.0488281 1.26562L1.1802 0.134254L16.8633 15.8174L15.7319 16.9487Z"
        fill="currentColor"
      />
      <path
        d="M0.0493168 15.8174L15.7324 0.134277L16.8638 1.26565L1.18069 16.9488L0.0493168 15.8174Z"
        fill="currentColor"
      />
    </svg>
  )
}
